import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "双向箭头",
  "use": "双向箭头-usage",
  "viewBox": "0 0 30 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 12\" id=\"双向箭头\"><defs><style>#双向箭头 .cls-1{fill:#a6a3d6;}</style></defs><g id=\"双向箭头_页面-1\"><g id=\"双向箭头_攻击模拟-Web安全-创建任务备份-2\"><g id=\"双向箭头_编组-13\"><polygon id=\"双向箭头_路径\" class=\"cls-1\" points=\"26.41 5.1 12.22 5.1 12.22 6.89 26.41 6.89 23.07 11.99 30 6 23.18 0 26.41 5.1\" /><polygon id=\"双向箭头_路径-2\" data-name=\"路径\" class=\"cls-1\" points=\"3.59 6.9 17.78 6.9 17.78 5.11 3.59 5.11 6.93 0.01 0 6 6.82 12 3.59 6.9\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol